// @flow

import React from "react"
import styled from "styled-components"

type Props = {
  bold?: boolean,
  children: Object,
  style?: Object,
  white?: boolean
}

const StyledParagraph = styled.p`
  color: #${p => (p.$white ? "fff" : "747474")};
  display: inline;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: 1.5;
  padding-bottom: 0px;
  margin-bottom: 0px;
  ${props =>
    props.$bold &&
    `
    font-weight: bold;
  `}
`

const ParagraphSecondary = ({
  children,
  white = false,
  bold,
  style
}: Props): React$Element<any> => {
  return (
    <StyledParagraph
      $white={white}
      $bold={bold}
      style={style}
      data-cy="cy_styled_paragraph"
    >
      {children}
    </StyledParagraph>
  )
}

export default ParagraphSecondary
